import { render } from "./PageSelect.vue?vue&type=template&id=210fef1a&scoped=true&ts=true"
import script from "./PageSelect.vue?vue&type=script&lang=ts"
export * from "./PageSelect.vue?vue&type=script&lang=ts"

import "./PageSelect.vue?vue&type=style&index=0&id=210fef1a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210fef1a"]])

export default __exports__